var _circle, _circle2, _circle3, _path, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCookie = function SvgCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 67,
    r: 67,
    fill: "#EBC645"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.8,
    cy: 13.4,
    r: 13.4,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.05,
    cy: 97.15,
    r: 6.7,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7 63.65a3.35 3.35 0 1 1-6.7 0 3.35 3.35 0 0 1 6.7 0Z",
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.6,
    cy: 40.2,
    r: 13.4,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.9,
    cy: 20.1,
    r: 13.4,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 33.5,
    r: 13.4,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.766,
    cy: 34.38,
    r: 8.307,
    fill: "#EBC645"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 13.4,
    r: 3.35,
    fill: "#EBC645"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.95,
    cy: 10.05,
    r: 6.7,
    fill: "#EBC645"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.55,
    cy: 83.75,
    r: 10.05,
    fill: "currentColor"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 73.7,
    r: 10.05,
    fill: "currentColor"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.45,
    cy: 56.95,
    r: 3.35,
    fill: "currentColor"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.95,
    cy: 36.85,
    r: 10.05,
    fill: "currentColor"
  })));
};

export default SvgCookie;